module.exports = __webpack_public_path__ + "img/programme1.b3eb497c.png";